import { render, staticRenderFns } from "./ViewLessonContent.vue?vue&type=template&id=5395d072&scoped=true"
import script from "./ViewLessonContent.vue?vue&type=script&lang=js"
export * from "./ViewLessonContent.vue?vue&type=script&lang=js"
import style0 from "./ViewLessonContent.vue?vue&type=style&index=0&id=5395d072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395d072",
  null
  
)

export default component.exports